export class EntityMetadata {
    commands: string[] = [];
}